import { ContextAware, DetailContext } from "@/app/contexts/detail.context";
import { ExternalContext } from "@/app/contexts/externalContext";
import {getObjectContentsFromPath} from "@/app/helpers/stringpath.helper";
import axios from "axios";
import Vue from "vue";
import {resolveEngine} from "@/app/helpers/resolve.engine";

class RuleEngine {

  public async resolveRuleAsync(context: ContextAware | undefined | null, ruleLine: string | boolean, v: Vue): Promise<boolean>{
    const result = await this.resolveRuleAsyncInteral(context, ruleLine, v);
    //console.log("resolved rule", ruleLine, result);
    return result;
  }


  public async resolveRuleAsyncInteral(context: ContextAware | undefined | null, ruleLine: string | boolean, v: Vue): Promise<boolean>{
    if(!context) return false;
    if(ruleLine === undefined || ruleLine === null || ruleLine === '') return true;
    if(ruleLine === 'true' || ruleLine === 'True') return true;
    if(ruleLine === 'false' || ruleLine === 'False') return false;
    if(ruleLine === true) return true;
    if(ruleLine === false) return false;

    while(ruleLine.includes('(') && ruleLine.includes(')')){
      ruleLine = await this.resolveParenthesisAsync(context, ruleLine, v);
    }

    let ruleAddition = '&&'
    let rules: string[] = [];
    if(ruleLine.includes('||')){
      ruleAddition = '||';
      rules = ruleLine.split('||');
    }else if(ruleLine.includes('&&')){
      ruleAddition = '&&';
      rules = ruleLine.split('&&');
    }else{
      rules = [ruleLine]
    }

    const results: boolean[] = [];

    for (const rule of rules) {
      if(rule === 'true' || rule === 'false'){
        results.push(rule === 'true');
        continue;
      }

      // 'data.dossier.lot:{eq:test}'
      // 'data.user.roles:{incl:test}'
      let indexOfSplit = rule.indexOf(':');
      while (rule.substring(indexOfSplit,indexOfSplit+2) === ':"'){
        indexOfSplit = rule.indexOf(':',indexOfSplit+1);
      }
      if(indexOfSplit < 0) {
        results.push(false);
        continue;
      }

      const field = rule.substring(0,indexOfSplit);
      const toParse = rule.substring(indexOfSplit+1);

      let op = '';
      let param = '';
      if(toParse.startsWith('{')){
        const indexOfOpsSplit = toParse.indexOf(':');
        if(indexOfOpsSplit < 0) false;
        op = toParse.substring(1, indexOfOpsSplit);
        param = toParse.substring(indexOfOpsSplit + 1);
        param = param.substring(0, param.length-1)
      }else{
        op = 'eq';
        param = toParse;
      }
      if(op === ''){
        results.push(false);
        continue;
      }

      const result = await this.resolveRuleDoAsync(context, field, op, param, v);
      results.push(result);
    }

    if(ruleAddition === '||'){
      return results.includes(true);
    }else if(ruleAddition === '&&'){
      return !results.includes(false);
    }else{
      return false;
    }
  }




  public resolveRule(context: ContextAware | undefined | null, ruleLine: string | boolean): boolean{
    if(!context) return false;
    if(ruleLine === undefined || ruleLine === null || ruleLine === '') return true;
    if(ruleLine === 'true' || ruleLine === 'True') return true;
    if(ruleLine === 'false' || ruleLine === 'False') return false;
    if(ruleLine === true) return true;
    if(ruleLine === false) return false;

    while(ruleLine.includes('(') && ruleLine.includes(')')){
      ruleLine = this.resolveParenthesis(context, ruleLine);
    }

    let ruleAddition = '&&'
    let rules: string[] = [];
    if(ruleLine.includes('||')){
      ruleAddition = '||';
      rules = ruleLine.split('||');
    }else if(ruleLine.includes('&&')){
      ruleAddition = '&&';
      rules = ruleLine.split('&&');
    }else{
      rules = [ruleLine]
    }

    const results: boolean[] = [];

    rules.forEach(rule => {
      if(rule === 'true' || rule === 'false'){
        results.push(rule === 'true');
        return;
      }

      // 'data.dossier.lot:{eq:test}'
      // 'data.user.roles:{incl:test}'
      const indexOfSplit = rule.indexOf(':');
      if(indexOfSplit < 0) {
        results.push(false);
        return;
      }

      const field = rule.substring(0,indexOfSplit);
      const toParse = rule.substring(indexOfSplit+1);

      let op = '';
      let param = '';
      if(toParse.startsWith('{')){
        const indexOfOpsSplit = toParse.indexOf(':');
        if(indexOfOpsSplit < 0) return false;
        op = toParse.substring(1, indexOfOpsSplit);
        param = toParse.substring(indexOfOpsSplit + 1);
        param = param.substring(0, param.length-1)
      }else{
        op = 'eq';
        param = toParse;
      }
      if(op === ''){
        results.push(false);
        return;
      }

      const result = this.resolveRuleDo(context, field, op, param);
      results.push(result);
    })

    if(ruleAddition === '||'){
      return results.includes(true);
    }else if(ruleAddition === '&&'){
      return !results.includes(false);
    }else{
      return false;
    }
  }

  private async resolveParenthesisAsync(context: ContextAware, ruleLine: string, v: Vue) {
    const regex = /\(([^()]+)\)/
    const results = ruleLine.match(regex);
    if (!results || results.length <= 0) return ruleLine;
    const result = await this.resolveRuleAsyncInteral(context, results[1], v)

    const replacedRuleLine = ruleLine.replace('('+ results[1] + ')', result+'');
    return replacedRuleLine
  }

  private resolveParenthesis(context: ContextAware, ruleLine: string) {
    const regex = /\(([^()]+)\)/
    const results = ruleLine.match(regex);
    if (!results || results.length <= 0) return ruleLine;
    const result = this.resolveRule(context, results[1])

    const replacedRuleLine = ruleLine.replace('('+ results[1] + ')', result+'');
    return replacedRuleLine
  }

  private resolveRuleDo(context: ContextAware, field: string, op: string, param: any): boolean {
    let fieldValue;
    fieldValue = resolveEngine.resolveFieldValue(field, context);
    if(param && typeof param === 'string'){
      param = resolveEngine.resolveFieldValue(param, context);
    }

    switch (op){
      case 'eq':
        if(typeof fieldValue !== "string" && typeof fieldValue !== "number") fieldValue = JSON.stringify(fieldValue);
        if(fieldValue === undefined) fieldValue = 'undefined';
        if(fieldValue === null) fieldValue = 'null';
        //console.log('rule exec', field, fieldValue, op, param, fieldValue === param);
        return fieldValue === param;
      case 'exists':{
        if(param === 'true'){
          return !!fieldValue;
        }else{
          return !fieldValue;
        }
      }
      case 'neq':
        if(typeof fieldValue !== "string" && typeof fieldValue !== "number") fieldValue = JSON.stringify(fieldValue);
        if(fieldValue === undefined) fieldValue = 'undefined';
        if(fieldValue === null) fieldValue = 'null';
        //console.log('rule exec', field, fieldValue, op, param, fieldValue !== param);
        return fieldValue !== param;
      case 'incl':
        if(!fieldValue) return false;
        if(Array.isArray(fieldValue)) return Array.from(fieldValue).includes(param);
        if(typeof fieldValue === "object") return Object.keys(fieldValue).includes(param);
        return false;
      case 'excl':
        if(!fieldValue) return true;
        if(Array.isArray(fieldValue)) return !Array.from(fieldValue).includes(param);
        if(typeof fieldValue === "object") return !Object.keys(fieldValue).includes(param);
        return true;
      case 'gt':
        if(typeof fieldValue === "string"){
          if(fieldValue === null || fieldValue === undefined || fieldValue === '') fieldValue = '0'
          fieldValue = Number.parseInt(fieldValue,10)
        }
        if(Number.isNaN(fieldValue)) return false;

        if(typeof param === "string"){
          if(param === null || param === undefined || param === '') param = '0'
          param = Number.parseInt(param,10)
        }
        if(Number.isNaN(param)) return false;
        return fieldValue > param;
      case 'lt':
        if(typeof fieldValue === "string"){
          if(fieldValue === null || fieldValue === undefined || fieldValue === '') fieldValue = '0'
          fieldValue = Number.parseInt(fieldValue,10)
        }
        if(Number.isNaN(fieldValue)) return false;

        if(typeof param === "string"){
          if(param === null || param === undefined || param === '') param = '0'
          param = Number.parseInt(param,10)
        }
        if(Number.isNaN(param)) return false;
        return fieldValue < param;
      case 'gte':
        if(typeof fieldValue === "string"){
          if(fieldValue === null || fieldValue === undefined || fieldValue === '') fieldValue = '0'
          fieldValue = Number.parseInt(fieldValue,10)
        }
        if(Number.isNaN(fieldValue)) return false;

        if(typeof param === "string"){
          if(param === null || param === undefined || param === '') param = '0'
          param = Number.parseInt(param,10)
        }
        if(Number.isNaN(param)) return false;
        return fieldValue >= param;
      case 'lte':
        if(typeof fieldValue === "string"){
          if(fieldValue === null || fieldValue === undefined || fieldValue === '') fieldValue = '0'
          fieldValue = Number.parseInt(fieldValue,10)
        }
        if(Number.isNaN(fieldValue)) return false;

        if(typeof param === "string"){
          if(param === null || param === undefined || param === '') param = '0'
          param = Number.parseInt(param,10)
        }
        if(Number.isNaN(param)) return false;
        return fieldValue <= param;
      default:
        return false;
    }
  }

  private async resolveRuleDoAsync(context: ContextAware, field: any, op: string, param: any, v: Vue): Promise<boolean> {
    let fieldValue;
    fieldValue = await resolveEngine.resolveFieldValueAsync(field, context, v);
    if(param && typeof param === 'string'){
      param = await resolveEngine.resolveFieldValueAsync(param, context, v);
    }

    switch (op){
      case 'eq':
        if(typeof fieldValue !== "string" && typeof fieldValue !== "number") fieldValue = JSON.stringify(fieldValue);
        if(fieldValue === undefined) fieldValue = 'undefined';
        if(fieldValue === null) fieldValue = 'null';
        //console.log('rule exec', field, fieldValue, op, param, fieldValue === param);
        return fieldValue === param;
      case 'exists':{
        if(param === 'true'){
          return !!fieldValue;
        }else{
          return !fieldValue;
        }
      }
      case 'neq':
        if(typeof fieldValue !== "string" && typeof fieldValue !== "number") fieldValue = JSON.stringify(fieldValue);
        if(fieldValue === undefined) fieldValue = 'undefined';
        if(fieldValue === null) fieldValue = 'null';
        //console.log('rule exec', field, fieldValue, op, param, fieldValue !== param);
        return fieldValue !== param;
      case 'incl':
        if(!fieldValue) return false;
        if(Array.isArray(fieldValue)) return Array.from(fieldValue).includes(param);
        if(typeof fieldValue === "object") return Object.keys(fieldValue).includes(param);
        return false;
      case 'excl':
        if(!fieldValue) return true;
        if(Array.isArray(fieldValue)) return !Array.from(fieldValue).includes(param);
        if(typeof fieldValue === "object") return !Object.keys(fieldValue).includes(param);
        return true;
      case 'gt':
        if(typeof fieldValue === "string"){
          if(fieldValue === null || fieldValue === undefined || fieldValue === '') fieldValue = '0'
          fieldValue = Number.parseInt(fieldValue,10)
        }
        if(Number.isNaN(fieldValue)) return false;

        if(typeof param === "string"){
          if(param === null || param === undefined || param === '') param = '0'
          param = Number.parseInt(param,10)
        }
        if(Number.isNaN(param)) return false;
        return fieldValue > param;
      case 'lt':
        if(typeof fieldValue === "string"){
          if(fieldValue === null || fieldValue === undefined || fieldValue === '') fieldValue = '0'
          fieldValue = Number.parseInt(fieldValue,10)
        }
        if(Number.isNaN(fieldValue)) return false;

        if(typeof param === "string"){
          if(param === null || param === undefined || param === '') param = '0'
          param = Number.parseInt(param,10)
        }
        if(Number.isNaN(param)) return false;
        return fieldValue < param;
      case 'gte':
        if(typeof fieldValue === "string"){
          if(fieldValue === null || fieldValue === undefined || fieldValue === '') fieldValue = '0'
          fieldValue = Number.parseInt(fieldValue,10)
        }
        if(Number.isNaN(fieldValue)) return false;

        if(typeof param === "string"){
          if(param === null || param === undefined || param === '') param = '0'
          param = Number.parseInt(param,10)
        }
        if(Number.isNaN(param)) return false;
        return fieldValue >= param;
      case 'lte':
        if(typeof fieldValue === "string"){
          if(fieldValue === null || fieldValue === undefined || fieldValue === '') fieldValue = '0'
          fieldValue = Number.parseInt(fieldValue,10)
        }
        if(Number.isNaN(fieldValue)) return false;

        if(typeof param === "string"){
          if(param === null || param === undefined || param === '') param = '0'
          param = Number.parseInt(param,10)
        }
        if(Number.isNaN(param)) return false;
        return fieldValue <= param;
      default:
        return false;
    }
  }
}

export const ruleEngine = new RuleEngine();
